import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState({
    name: "",
    price: "",
    description: "",
    imageUrl: "",
  });
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const docRef = doc(db, "products", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setProduct(docSnap.data());
        } else {
          alert("❌ المنتج غير موجود");
          navigate("/products");
        }
      } catch (error) {
        console.error("خطأ أثناء تحميل المنتج:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id, navigate]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "salma_pro"); // غيّرها حسب إعدادك

    try {
      const response = await fetch("https://api.cloudinary.com/v1_1/dys8jv8c2/upload", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.secure_url) {
        setProduct((prev) => ({ ...prev, imageUrl: data.secure_url }));
      } else {
        alert("❌ فشل رفع الصورة");
      }
    } catch (error) {
      console.error("خطأ أثناء رفع الصورة:", error);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(db, "products", id);
      await updateDoc(docRef, {
        name: product.name,
        price: product.price,
        description: product.description,
        imageUrl: product.imageUrl,
      });
      alert("✅ تم تحديث المنتج بنجاح");
      navigate("/products");
    } catch (error) {
      console.error("خطأ أثناء التحديث:", error);
      alert("❌ حدث خطأ أثناء التحديث");
    }
  };

  if (loading)
    return <p style={styles.loadingText}>⏳ جاري تحميل بيانات المنتج...</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>✏️ تعديل المنتج</h2>

      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>اسم المنتج</label>
          <input
            type="text"
            value={product.name}
            onChange={(e) => setProduct({ ...product, name: e.target.value })}
            style={styles.input}
            required
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>السعر</label>
          <input
            type="number"
            value={product.price}
            onChange={(e) => setProduct({ ...product, price: e.target.value })}
            style={styles.input}
            required
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>الوصف</label>
          <textarea
            value={product.description}
            onChange={(e) =>
              setProduct({ ...product, description: e.target.value })
            }
            style={styles.textarea}
            rows="3"
            required
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>الصورة</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={styles.fileInput}
          />
          {uploading && <p style={styles.uploading}>جاري رفع الصورة...</p>}
          {product.imageUrl && (
            <img
              src={product.imageUrl}
              alt="Preview"
              style={styles.imagePreview}
            />
          )}
        </div>

        <button
          type="submit"
          style={{
            ...styles.button,
            backgroundColor: uploading ? "#9ca3af" : "#16a34a",
          }}
          disabled={uploading}
        >
          {uploading ? "جاري الحفظ..." : "حفظ التعديلات ✅"}
        </button>
      </form>
    </div>
  );
};

// 🎨 CSS داخل نفس الملف
const styles = {
  container: {
    backgroundColor: "#f9fafb",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 20px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "25px",
  },
  form: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "480px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "6px",
    fontWeight: "600",
    color: "#374151",
  },
  input: {
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    fontSize: "15px",
  },
  textarea: {
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    resize: "none",
    minHeight: "90px",
    fontSize: "15px",
  },
  fileInput: {
    border: "1px dashed #9ca3af",
    padding: "8px",
    borderRadius: "10px",
    backgroundColor: "#f3f4f6",
  },
  uploading: {
    color: "#2563eb",
    marginTop: "5px",
    fontSize: "14px",
  },
  imagePreview: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    borderRadius: "10px",
    marginTop: "10px",
  },
  button: {
    marginTop: "10px",
    color: "#fff",
    padding: "12px",
    border: "none",
    borderRadius: "10px",
    fontSize: "16px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "0.3s",
  },
  loadingText: {
    textAlign: "center",
    marginTop: "100px",
    fontSize: "20px",
    color: "#6b7280",
  },
};

export default EditProduct;
